// Env
export default `https://test-api.candidate-concierge.com`;

//Localhost
//export default `https://localhost:44399`;